module.exports = __webpack_public_path__ + "img/404.c12d10e6.svg";